import { Component, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { IdleUserMonitor } from './authentication/idle-user-monitor';

@Component({
    selector: 'application',
    template: require('./app.html'),
    styles: [require('../app.scss'), require('../grid.scss'), require('../cvd3.scss')],
    encapsulation: ViewEncapsulation.None
})
export class AppComponent implements AfterViewInit {

    constructor(private idleUserMonitor: IdleUserMonitor) {
    }

    public ngAfterViewInit() {
        this.idleUserMonitor.start();
    }
}